export default "__VITE_ASSET__d610bff4__"